/**
 * @param {object} item - Item..
 * @param {object[]} columns - Column data.
 * @param {Array} rounds - rounds list.
 * @param predicted
 * @returns {object[]} Row data for the given player.
 */
export const composePredictorRowData = (item, columns, rounds, predicted) => {
    const byeRounds =
        rounds
            ?.filter((round) =>
                round.byes?.some((bye) => bye.providerId === item?.team.teamId)
            )
            ?.map((round) => round.roundNumber) ?? [];

    const predictedVotes = predicted?.find(
        (predictedItem) =>
            item.player.playerId === predictedItem.providerId ||
            item.player.providerId === predictedItem.providerId
    );

    return {
        player: {
            eligible: item?.eligible ?? false,
            givenName: item?.player.firstName ?? '',
            surname: item?.player.surname ?? '',
            photoURL: item?.player.photoURL ?? '',
            playerId: item?.player.providerId ?? '',
            winner: item?.player.winner ?? false,
            position: item?.position ?? null
        },
        ...columns.reduce((prev, curr) => {
            let roundData = {
                actual: '',
                predicted: '',
                played: true
            };

            if (
                byeRounds.includes(parseInt(curr.accessor.replace('round', '')))
            ) {
                roundData.actual = 'B';
            } else {
                item?.roundByRoundTotalVotes?.forEach((round) => {
                    if (curr.accessor === 'round' + round.roundNumber) {
                        roundData.actual = round.votes;
                        return;
                    }
                });
            }

            if (predictedVotes) {
                Object.keys(predictedVotes.rounds).forEach((key) => {
                    if (
                        parseInt(curr.accessor.replace('round', '')) ===
                        parseInt(key)
                    ) {
                        const data = predictedVotes.rounds[key];
                        const cumulativePoints = data
                            .map((round) => (round.points ? round.points : 0))
                            .reduce(
                                (roundCurr, roundAcc) => roundCurr + roundAcc
                            );

                        roundData.actual = cumulativePoints || '';

                        // bye rounds will only have 1 obj
                        if (data.length === 1) {
                            if (data[0].bye) {
                                roundData.actual = 'B';
                            }

                            if (data[0].played === false && !data[0].bye) {
                                roundData.played = false;
                                roundData.actual = 'NP';
                            }
                        }
                    }
                });
            }

            return {
                ...prev,
                [curr.accessor]: roundData
            };
        }, {}),
        totalVotes: predictedVotes?.totalVotes ?? 0,
        bettingOdds: item?.bettingOdds ?? 0
    };
};
